// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { PortalHomeRoute } from '@Modules/Portal';
import { type RouteObject } from 'react-router';

export function setupPortalRouting(): RouteObject {
    return {
        path: 'home',
        element: <PortalHomeRoute />,
    };
}
